// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__KDhPU","content":"RecentSearches_content__2Hh8a"};